<p-sidebar [(visible)]="parent.showFilterSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (visibleChange)="parent.onFilterClear($event)">
    <ng-template pTemplate="header" class="filter-header filter-text-color">Filter</ng-template>

    <div class="flex flex-column">
        <mat-label class="filter-label filter-text-color mb-2 mt-4">Date</mat-label>
        <div class="flex">
            <p-calendar class="filter-input calendar-input" [showButtonBar]="true"
                        [(ngModel)]="parent.filter.createdAt"
                        placeholder="Select Date"></p-calendar>
            <img src="../Content/xpress-app/images/svg/icon_calendar.svg" class="icon_calendar" />
        </div>
    </div>

    <div class="flex flex-column mt-3">
        <mat-label class="filter-label filter-text-color mb-2 mt-1">Location(Store)</mat-label>
        <mat-select [placeholder]="'Select Location(Store)'" [(value)]="parent.filter.locationId">
            <mat-option *ngFor="let location of parent.locations" [value]="location.Id">
                {{ location.Name }}
            </mat-option>
        </mat-select>
    </div>

    <div class="flex flex-column mt-2">
        <mat-label class="filter-label filter-text-color mb-2 mt-4">Order Type</mat-label>
        <ng-container *ngFor="let orderType of parent.orderTypes; let i = index;">
            <div class="flex align-items-center filter-elem-height">
                <p-radioButton [value]="orderType.Id" [(ngModel)]="parent.filter.orderTypeId" inputId="orderStatusFilter+{{i}}"></p-radioButton>
                <mat-label class="ml-3 filter-value filter-text-color">{{orderType.Name}}</mat-label>
            </div>
        </ng-container>
    </div>

    <div class="flex flex-column mt-2 mb-3">
        <mat-label class="filter-label filter-text-color mb-2 mt-4">Status</mat-label>
        <ng-container *ngFor="let status of parent.statuses; let i = index;">
            <div class="flex align-items-center filter-elem-height">
                <p-radioButton [value]="status.Id" [(ngModel)]="parent.filter.statusId" inputId="orderStatusFilter+{{i}}"></p-radioButton>
                <mat-label class="ml-3 filter-value filter-text-color">{{status.Name}}</mat-label>
            </div>
        </ng-container>
    </div>

    <ng-template pTemplate="footer" class="flex justify-content-start mt-4">
        <button pButton class="btn-darkblue filter-button" label="Apply" (click)="parent.onFilterApply()"></button>
        <button pButton class="btn-secondary filter-button ml-3" label="Cancel" (click)="parent.onFilterClear(null)"></button>
    </ng-template>
</p-sidebar>
